import io from 'socket.io-client'

export default defineNuxtPlugin((nuxtApp) => {
  const store = nuxtApp.$store as any
  const EventBus = nuxtApp.$eventbus as any

  let socket = io({ 
    query: {
      shopId: store.state.shopId,
      apiKey: store.getters.apiKey,
      clientId: store.state.clientid,
      tabId: store.state.tabid,
      lastSeenTs: store.state.lastSeenMessageTs
    },
    reconnection: store.getters.apiKey ? true : false,
    transports: ['websocket'] // Only use WebSocket
  })
  // Let's no longer attempt long polling in any situation
  /*
  socket.on("connect_error", (err) => {
    // revert to classic upgrade
    socket.io.opts.transports = ["polling", "websocket"];
//    console.log('socket.io client error', err)
  })
  */
  socket.on('disconnect', () => {
    EventBus.$emit('socketDisconnected')
    if (socket.io.opts.query) {
      socket.io.opts.query.lastSeenTs = store.state.lastSeenMessageTs
    }
  })
  socket.on('connect', () => {
    EventBus.$emit('socketConnected')
  })
  /*
  socket.on('reconnect_attempt', () => {
    console.log('RECONNECT ATTEMPT')
    socket.io.opts.query = {
      shopId: store.state.shopId,
      apiKey: store.getters.apiKey
    }
  })
  */

  store.watch(
    (_state, getters) => getters.apiKey,
    (newValue) => {
    if (newValue) {
      socket.io.reconnection(true)
    } else {
      socket.io.reconnection(false)
    }
    socket.disconnect()
    if (newValue) {
      // console.log('connecting with', newValue)
      socket.io.opts.query = {
        shopId: store.state.shopId,
        apiKey: store.getters.apiKey,
        clientId: store.state.clientid,
        tabId: store.state.tabid,
        lastSeenTs: store.state.lastSeenMessageTs
      }
      socket.connect()
    }
  })
  return {
    provide: {
      socket: socket
    }
  }
})